import { Loader } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'

export const RepositorySelectorFallback = () => (
  <div className="flex items-end gap-4 w-full">
    <div className="w-full">
      <Label>Repository</Label>
      <Skeleton className="h-9 w-full mt-2" />
    </div>
    <Button
      type="button"
      disabled={true}
      variant="secondary"
      size="icon"
      aria-label="Loading repositories"
    >
      <Loader className="animate-spin size-4" />
    </Button>
  </div>
)
